<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Yükleme Modu</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Yükleme Modu" v-model="value.Name"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    },
}
</script>

<style>

</style>